declare const jQuery: any;
const $ = jQuery;

export function initMainBanner(): void
{
	const $banner = $(document.getElementById("main-banner"));
	if ($banner.length === 0)
	{
		return;
	}
	setTimeout(function () {
		$banner.addClass("loaded");
	}, 1000);
}
